'use strict';

module.exports = function(app) {

    app.formLabels = function() {
        var formGroup = $('.form-group');

        formGroup.each(function() {
            var label = $(this).children('label');
            var input = $(this).children('input, select, textarea');

            if (input && input.val() && input.length && input.val().length) {
                label.addClass('fade');
            }
        });
    };

    return app;
};
